var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssuing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 194,
    viewBox: "0 0 273 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.178 0H55.8923C48.2392 0 42.0352 6.20405 42.0352 13.8571V180.143C42.0352 187.796 48.2392 194 55.8923 194H222.178C229.831 194 236.035 187.796 236.035 180.143V13.8571C236.035 6.20405 229.831 0 222.178 0Z",
    fill: "url(#paint0_linear_8598_11954)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8598_11954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 13.8574H12.9286C9.10203 13.8574 6 16.9594 6 20.786V55.4289C6 59.2554 9.10203 62.3574 12.9286 62.3574H200C203.827 62.3574 206.929 59.2554 206.929 55.4289V20.786C206.929 16.9594 203.827 13.8574 200 13.8574Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.619 24.9434H65.5907C63.2948 24.9434 61.4336 26.8046 61.4336 29.1005C61.4336 31.3964 63.2948 33.2576 65.5907 33.2576H101.619C103.915 33.2576 105.776 31.3964 105.776 29.1005C105.776 26.8046 103.915 24.9434 101.619 24.9434Z",
    fill: "#B4DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.562 42.957H65.5907C63.2948 42.957 61.4336 44.8182 61.4336 47.1142C61.4336 49.4101 63.2948 51.2713 65.5907 51.2713H126.562C128.858 51.2713 130.719 49.4101 130.719 47.1142C130.719 44.8182 128.858 42.957 126.562 42.957Z",
    fill: "#DEE9FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4173 18.0146H17.0887C13.2622 18.0146 10.1602 21.1167 10.1602 24.9432V51.2718C10.1602 55.0983 13.2622 58.2004 17.0887 58.2004H43.4173C47.2438 58.2004 50.3459 55.0983 50.3459 51.2718V24.9432C50.3459 21.1167 47.2438 18.0146 43.4173 18.0146Z",
    fill: "#1485FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0195 39.0768L27.5828 42.9568L36.491 33.2568",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8598_11954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5145 73.4424H259.586C261.423 73.4424 263.186 74.1724 264.485 75.4717C265.785 76.7711 266.514 78.5334 266.514 80.371V115.014C266.514 116.851 265.785 118.614 264.485 119.913C263.186 121.212 261.423 121.942 259.586 121.942H72.5145C70.6769 121.942 68.9146 121.212 67.6153 119.913C66.3159 118.614 65.5859 116.851 65.5859 115.014V80.371C65.5859 78.5334 66.3159 76.7711 67.6153 75.4717C68.9146 74.1724 70.6769 73.4424 72.5145 73.4424V73.4424Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.205 84.5273H125.177C122.881 84.5273 121.02 86.3886 121.02 88.6845C121.02 90.9804 122.881 92.8416 125.177 92.8416H161.205C163.501 92.8416 165.362 90.9804 165.362 88.6845C165.362 86.3886 163.501 84.5273 161.205 84.5273Z",
    fill: "#B4DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.148 102.541H125.177C122.881 102.541 121.02 104.402 121.02 106.698C121.02 108.994 122.881 110.855 125.177 110.855H186.148C188.444 110.855 190.305 108.994 190.305 106.698C190.305 104.402 188.444 102.541 186.148 102.541Z",
    fill: "#DEE9FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.999 77.5996H76.6708C72.8442 77.5996 69.7422 80.7016 69.7422 84.5282V110.857C69.7422 114.683 72.8442 117.785 76.6708 117.785H102.999C106.826 117.785 109.928 114.683 109.928 110.857V84.5282C109.928 80.7016 106.826 77.5996 102.999 77.5996Z",
    fill: "#1485FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6016 98.6618L87.1648 102.542L96.073 92.8418",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8598_11954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9286 133.027H200C201.838 133.027 203.6 133.757 204.899 135.057C206.199 136.356 206.929 138.118 206.929 139.956V174.599C206.929 176.436 206.199 178.199 204.899 179.498C203.6 180.797 201.838 181.527 200 181.527H12.9286C11.091 181.527 9.32869 180.797 8.02933 179.498C6.72997 178.199 6 176.436 6 174.599V139.956C6 138.118 6.72997 136.356 8.02933 135.057C9.32869 133.757 11.091 133.027 12.9286 133.027V133.027Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.619 144.113H65.5907C63.2948 144.113 61.4336 145.974 61.4336 148.27C61.4336 150.566 63.2948 152.428 65.5907 152.428H101.619C103.915 152.428 105.776 150.566 105.776 148.27C105.776 145.974 103.915 144.113 101.619 144.113Z",
    fill: "#B4DAFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.562 162.127H65.5907C63.2948 162.127 61.4336 163.988 61.4336 166.284C61.4336 168.58 63.2948 170.441 65.5907 170.441H126.562C128.858 170.441 130.719 168.58 130.719 166.284C130.719 163.988 128.858 162.127 126.562 162.127Z",
    fill: "#DEE9FC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4134 137.186H17.0848C13.2583 137.186 10.1562 140.288 10.1562 144.114V170.443C10.1562 174.269 13.2583 177.371 17.0848 177.371H43.4134C47.2399 177.371 50.342 174.269 50.342 170.443V144.114C50.342 140.288 47.2399 137.186 43.4134 137.186Z",
    fill: "#1485FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0156 158.248L27.5789 162.128L36.4871 152.428",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8598_11954",
    x: 0,
    y: 10.8574,
    width: 212.93,
    height: 60.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8598_11954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8598_11954",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8598_11954",
    x: 59.5859,
    y: 70.4424,
    width: 212.93,
    height: 60.499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8598_11954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8598_11954",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8598_11954",
    x: 0,
    y: 130.027,
    width: 212.93,
    height: 60.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8598_11954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8598_11954",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8598_11954",
    x1: 139.035,
    y1: 0,
    x2: 139.035,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuing);
export default __webpack_public_path__ + "static/media/issuing.7736e1f45b63f049fa139b104d92becb.svg";
export { ForwardRef as ReactComponent };